import type { ExtractedFacts } from '../api/onboarding-types'

/** What the sample CofA / SDS themselves say, next to what was entered. */
export function ExtractionPanel({
  state,
  results,
}: {
  state: 'none' | 'pending' | 'running' | 'complete' | 'failed'
  results: Record<string, ExtractedFacts>
}) {
  const entries = Object.entries(results)
  if (state === 'none' && !entries.length) {
    return <p className="text-sm text-tertiary">Upload the sample CofA and SDS to have them read and compared.</p>
  }
  return (
    <div className="flex flex-col gap-3">
      {state === 'pending' || state === 'running' ? (
        <p className="text-sm text-secondary">Reading the documents…</p>
      ) : null}
      {entries.map(([key, f]) => (
        <div key={key} className="rounded-md border border-border-subtle p-3 text-sm">
          <div className="mb-1 font-medium">{f.doc_type_label ?? key}</div>
          {f.error ? (
            <p className="text-danger-text">
              {/FileNotFound|no retrievable copy/.test(f.error)
                ? "The file couldn't be opened. Upload the same PDF again, then read the documents again."
                : f.error}
            </p>
          ) : (
            <dl className="grid grid-cols-[auto_1fr] gap-x-3 gap-y-1">
              <dt className="text-secondary">Product</dt>
              <dd>{f.product_name ?? '—'}</dd>
              <dt className="text-secondary">Manufacturer</dt>
              <dd>{f.manufacturer ?? '—'}</dd>
              {f.manufacturer_address ? (
                <>
                  <dt className="text-secondary">Address</dt>
                  <dd>{f.manufacturer_address}</dd>
                </>
              ) : null}
              {f.emergency_phone ? (
                <>
                  <dt className="text-secondary">Emergency phone</dt>
                  <dd>{f.emergency_phone}</dd>
                </>
              ) : null}
              {f.supplier ? (
                <>
                  <dt className="text-secondary">Supplier</dt>
                  <dd>{f.supplier}</dd>
                </>
              ) : null}
              <dt className="text-secondary">INCI</dt>
              <dd>{f.inci_names?.length ? f.inci_names.join(', ') : '—'}</dd>
              <dt className="text-secondary">CAS</dt>
              <dd>{f.cas_numbers?.length ? f.cas_numbers.join(', ') : '—'}</dd>
              {f.lot_number ? (
                <>
                  <dt className="text-secondary">Lot</dt>
                  <dd>{f.lot_number}</dd>
                </>
              ) : null}
            </dl>
          )}
        </div>
      ))}
    </div>
  )
}
